const ProcurementLaneType = {
  GET_PROCUREMENT_LANE_LIST: 'GET_PROCUREMENT_LANE_LIST',
  GET_PROCUREMENT_LANE_LIST_SUCCESS: 'GET_PROCUREMENT_LANE_LIST_SUCCESS',
  GET_PROCUREMENT_LANE_LIST_FAIL: 'GET_PROCUREMENT_LANE_LIST_FAIL',
  SET_PROCUREMENT_LANE_LIST_REQUEST: 'SET_PROCUREMENT_LANE_LIST_REQUEST',
  RESET_PROCUREMENT_LANE_LIST: 'RESET_PROCUREMENT_LANE_LIST',
  SET_ADD_NEW_LANE: 'SET_ADD_NEW_LANE',
  SELECTED_LANE_LIST: 'SELECTED_LANE_LIST',
};

export default ProcurementLaneType;
